export const AUTH_STATE_KEY = 'auth';
